export default __webpack_public_path__ + "static/media/aq.21c2fb02.svg";